import { createSlice } from '@reduxjs/toolkit';

import { actualizePackageSuccess } from '../actions/actualization';
import type { HotelStateType } from '../hotel/types';

const initialState: Partial<HotelStateType> = {};

const hotelSlice = createSlice({
  name: 'hotel',
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder.addCase(actualizePackageSuccess, (state, { payload }) => {
      const {
        data: { meta_policies: metapolicies },
      } = payload;

      return {
        ...state,
        metapolicies,
      };
    }),
});

export default hotelSlice.reducer;
